export enum TipoReporteMovimientos {
    Fecha = 0,
    CierreTurno = 1
}